import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BpService } from '../../../../core/services/bp.service';
import { KkmsService } from '../../../../core/services/kkms.service';
import { DeregisterKkmFields, DeregisterKkmForm, DeregisterKkmSignatureForm } from './deregister-kkm.model';
import { KkmProcessService } from '../../shared/services/kkm-process.service';
import { PreviousPage } from '../../../../core/models/bp.model';

@UntilDestroy()
@Component({
  selector: 'tax-deregister-kkm',
  templateUrl: 'deregister-kkm.component.html',
})

export class DeregisterKkmComponent implements OnInit {
  processForm?: DeregisterKkmForm | DeregisterKkmSignatureForm;

  constructor(
    private bpService: BpService,
    private route: ActivatedRoute,
    private kkmsService: KkmsService,
    private kkmProcessService: KkmProcessService,
  ) {}

  ngOnInit(): void {
    this.initDeregisterProcess();
  }

  goToSignStep(kkmForm: DeregisterKkmFields): void {
    this.kkmProcessService.processKkmFormWithRcaCheck<DeregisterKkmSignatureForm, DeregisterKkmFields>(kkmForm)
      .pipe(untilDestroyed(this))
      .subscribe((processForm) => {
        this.processForm = processForm;
      });
  }

  goToFirstStep(): void {
    this.bpService.goToStepAndGetForm(
      'inisBackToDeregistrationFormMessage',
      `/main/kkms/deregister-kkm/${this.route.snapshot.params.kkmId}`,
      {},
    )
      .pipe(untilDestroyed(this))
      // @ts-ignore
      .subscribe((processForm: DeregisterKkmForm) => {
        this.processForm = processForm;
      });
  }

  private getDeregisterKkmForm(kkmId: string): void {
    this.bpService.startBpAndGetData('inisDeregistrationKkmMessage', {
      kkmId,
    })
      .pipe(
        // @ts-ignore
        switchMap((form: DeregisterKkmForm) => {
          this.processForm = form;
          return form.fields.declineReason
            ? this.kkmsService.getDeclineReason(form.fields.declineReason)
            : of(true);
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }

  private initDeregisterProcess(): void {
    const savedKkmForm = (history?.state as PreviousPage<DeregisterKkmFields>)?.state;
    // Условие для продолжения БП снятия с учета кассы после корректировки адреса и РКА ТТ
    if (savedKkmForm) {
      if (history?.state?.isUpdatedRca) {
        this.bpService.submitAndGetForm<DeregisterKkmSignatureForm>(savedKkmForm)
          .pipe(untilDestroyed(this))
          .subscribe((processForm) => {
            this.processForm = processForm;
          });
      } else {
        this.processForm = {
          ...this.processForm, formKey: 'kkm-deregistration-manually', fields: savedKkmForm,
        };
      }
    } else {
      this.route.params
        .pipe(untilDestroyed(this))
        .subscribe((params) => {
          this.getDeregisterKkmForm(params.kkmId);
        });
    }
  }
}
